// PageAbsent Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageBase from '../page_base/page_base.jsx'
import PageHeaderUser from '../../layout/page_headeruser/page_headeruser.jsx'
import ContentMessage from '../../common/content_message/content_message.jsx'
import AddButton from '../../common/add_button/add_button.jsx'
import DialogUserAddAbsent from '../../dialog/dialog_user_addabsent/dialog_user_addabsent.jsx'
import UserAbsentItem from '../../user/user_absentitem/user_absentitem.jsx'

class PageAbsent extends PageBase {
  constructor (props) {
    super(props, 'user-absent', 'user-user', 'user-absent')

    this.state = {
      loading: true,
      dataDate: null,
      pageNo: 1
    }

    this.data = {
      userleaves: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      pageNo: 1
    }

    this._references = {
      dialogAbsentAdd: React.createRef()
    }
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    return (
      <div className='page-absent'>
        {this._renderMessage()}
        <div className='list'>{this._renderItems()}</div>
        {this._renderAdd()}
        <DialogUserAddAbsent
          ref={this._references.dialogAbsentAdd}
          absent={this.data.userleaves}
          onSubmit={this._onSubmit.bind(this)}
        />
      </div>
    )
  }

  renderHeader () {
    return (
      <PageHeaderUser
        title='user.profile.title'
        pageIdent='user-absent'
        onChangePage={this._onChangePage.bind(this)}
      />
    )
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onAdd (ev) {
    ev.preventDefault()
    if (this._references.dialogAbsentAdd.current) {
      this._references.dialogAbsentAdd.current.show()
    }
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        (done) => {
          this._getPageData(done)
        },
        (done) => {
          this._getDataUserLeaves(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _renderItems () {
    if (this.data.userleaves && this.data.userleaves.length > 0) {
      return this.data.userleaves.map((leave, idx) => {
        return <UserAbsentItem absent={leave} key={idx} />
      })
    }

    return ''
  }

  _getDataUserLeaves (callback) {
    const params = {
      userId: app.loggedInId
    }

    app
      .service('/api/user/leave')
      .find(params)
      .then((result) => {
        this.data.userleaves =
          this.data.pageNo > 1
            ? this.data.userleaves.concat(result.data)
            : result.data
        this.data.total = result.total
        this.data.countLoaded = params.query.$limit * this.data.pageNo
        this.data.canPaginate =
          !(this.data.countLoaded > this.data.total)
        callback(null)
      })
      .catch((err) => {
        app.debug('PageAbsent: _getDataUserLeaves err', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (err) {
      app.debug('PageAbsent: _onDataReceived Error', err)
      this.setState({ loading: true, dataDate: new Date() })
    } else {
      app.debug('PageAbsent: _onDataReceived [done]')
      this.setState({
        loading: !(this.data.userleaves && this.data.userleaves.length > 0),
        dataDate: new Date()
      })
    }
  }

  _renderMessage () {
    if (this.state.loading) {
      return (
        <ContentMessage
          message='user.absent.noAbsentTitle'
          info='user.absent.addAbsentInfo'
          showAddPrefix={false}
          showAdd
          onAdd={this._onAdd.bind(this)}
        />
      )
    }

    return ''
  }

  _renderAdd () {
    return (
      <AddButton
        title='user.absent.createAbsent'
        onClick={this._onAdd.bind(this)}
      />
    )
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSubmit (leaveData) {
    leaveData.userId = app.loggedInId
    app
      .service('/api/user/leave')
      .create(leaveData)
      .then((leaveRes) => {
        this.data.userleaves.push(leaveRes)
        if (this._references.dialogAbsentAdd.current) {
          this._references.dialogAbsentAdd.current.hide()
        }
        this.setState({ dataDate: new Date() })
      })
      .catch((leaveErr) => {
        app.debug('PageAbsent: _saveContact Error', leaveErr)
      })
  }
}

export default PageAbsent
